import { jsxs as r, jsx as a } from "react/jsx-runtime";
import { c as s } from "../../../index-CvSFHqCB.js";
import * as c from "react";
import { c as g } from "../../../utils-BOFVZgHd.js";
import { Label as h } from "../../ui/label.js";
import { Select as S, SelectTrigger as b, SelectValue as V, SelectContent as w, SelectItem as I } from "../../ui/select.js";
const N = s("flex flex-col gap-1.5", {
  variants: {
    size: {
      default: "",
      sm: "max-w-sm",
      lg: "max-w-lg",
      full: "w-full"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), F = s(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  {
    variants: {
      error: {
        true: "text-[var(--destructive)]",
        false: "text-[var(--foreground)]"
      }
    },
    defaultVariants: {
      error: !1
    }
  }
), y = s("text-sm text-[var(--destructive)]", {
  variants: {
    size: {
      default: "",
      sm: "text-xs",
      lg: "text-base",
      full: ""
    }
  },
  defaultVariants: {
    size: "default"
  }
}), z = c.forwardRef(
  ({ className: n, size: i, label: d, error: e, required: o, field: f, fieldControl: m, id: u, options: x }, p) => {
    const v = c.useId(), l = u || f?.fieldId || v;
    return /* @__PURE__ */ r("div", { className: "w-full flex flex-col gap-1.5", children: [
      d && /* @__PURE__ */ r(h, { htmlFor: l, className: F({ error: !!e }), children: [
        d,
        o && " *"
      ] }),
      /* @__PURE__ */ r(S, { ...m?.field || {}, children: [
        /* @__PURE__ */ a(
          b,
          {
            ref: p,
            id: l,
            className: g(N({ size: i, className: n })),
            "aria-describedby": e ? `${l}-error` : void 0,
            "aria-invalid": !!e,
            children: /* @__PURE__ */ a(V, { placeholder: "Select an option" })
          }
        ),
        /* @__PURE__ */ a(w, { children: x.map((t) => /* @__PURE__ */ a(I, { value: t.value, children: t.label }, t.value)) })
      ] }),
      e && /* @__PURE__ */ a("p", { className: y({ size: i }), id: `${l}-error`, children: e })
    ] });
  }
);
z.displayName = "SelectField";
export {
  z as SelectField,
  N as selectFieldVariants
};
//# sourceMappingURL=index.js.map
